import { faCircleInfo } from "@jewlr/pro-light-svg-icons/faCircleInfo"
// import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_AU, IS_CA, isTestMode, IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

import WizardPricingLoading from "./loaders/wizard-pricing-loading"
import Badge from "./wizard-header/badge"

const ProductPrice = ({ miniview }) => {
  const pricing = useSelector((state) => state.wizard.price_and_promo)
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const onSale = pricing && pricing.on_sale

  if (!Object.keys(pricing).length || wizardLoading) {
    return <WizardPricingLoading />
  } else if (pricing.price_to_display <= 0) {
    return ""
  }

  // const percentageSavings = (
  //   ((pricing.retail_price - pricing.price_to_display) * 100) /
  //   pricing.retail_price
  // ).toFixed(0)

  const currencyCode = IS_AU() ? "AU" : IS_CA() ? "C" : ""

  const handleHonestPricingClick = () => {
    openModal("#honest-pricing")
    if (!isTestMode) {
      dataLayer.push({
        event: "opened-pdp-honest-pricing-popup",
      })
    }
  }

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.price_to_display}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }
  return (
    <div className="tablet:mt-10 mt-8">
      <div
        className={cn(
          "text-22 tablet:text-24 leading-24 tablet:leading-26 tablet:gap-10 mb-6 flex items-center gap-8 font-bold"
        )}
        {...globaleAttrs.container}
      >
        {onSale && (
          <p className={cn("text-grey-400 font-medium", miniview && "text-18")}>
            <strike {...globaleAttrs.reg}>
              {currencyCode}
              {to_currency(pricing.regular_pricing)}
            </strike>
          </p>
        )}
        <h2
          className={cn(onSale ? "text-ruby" : "text-black")}
          data-cy="product-item-price"
          data-ge-parentproduct-total-price
          {...globaleAttrs.display}
        >
          {currencyCode}
          {to_currency(pricing.price_to_display)}
        </h2>
        {onSale && <Badge />}
      </div>
      {IS_JEWLR() && (
        <div className="text-12 tablet:tracking-wide flex items-center leading-none -tracking-tight">
          {/* <p className="text-ruby tablet:font-medium font-semibold">
            SAVE {percentageSavings}%
          </p>
          <div
            className="tablet:bg-grey-35 tablet:mx-8 mx-4 bg-black"
            role="separator"
            style={{ height: "12px", width: "1px" }}
          /> */}
          <Button
            aria-label={`Compare to ${to_currency(
              pricing.retail_price
            )} Estimated Retail. Read more about our value pricing`}
            onClick={handleHonestPricingClick}
          >
            <p className="text-10 tablet:12px tablet:font-light tablet:tracking-wide tablet:leading-14 tablet:no-underline tablet:normal-case font-semibold uppercase leading-none -tracking-tight">
              Compare to {to_currency(pricing.retail_price)} Estimated Retail
            </p>
            <FontAwesomeIcon
              className="text-12 tablet:text-10 ml-4"
              icon={faCircleInfo}
            />
          </Button>
        </div>
      )}
      {new Date().setHours(0, 0, 0, 0) <=
        new Date(pricing.sale_ends).setHours(0, 0, 0, 0) && (
        <p className="text-grey-500 text-12 mt-4">
          Sale ends {pricing.sale_ends}
        </p>
      )}
    </div>
  )
}

ProductPrice.propTypes = {
  miniview: PropTypes.bool,
}

export default ProductPrice
